import HeaderPage from './HeaderPage';

export default HeaderPage;
export * from './types';
export { HeaderPage };
